import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import smoothScroll from 'smoothscroll';

import { fetchOpinions } from '../actions/index';

import Opinion from './opinion';
import Jurisdictions from './filters/jurisdictions';
import SearchForm from './filters/search-form';
import OpinionStatus from './filters/opinion-status';
import LimitCount from './filters/limit-count';
import Pagination from './filters/pagination';
import OpinionsSideBar from './opinion-sidebar';
import Loading from '../../components/loading-component';

import { searchOpinions } from '../actions/index';

class OpinionsList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showFilters: false
		};
		this.toggleFilters = this.toggleFilters.bind(this);
	}

	componentWillMount() {
		this.props.fetchOpinions();
	}

	toggleFilters() {
		this.setState(prevState => {
		  const newShowFilters = !prevState.showFilters;
		  return { showFilters: newShowFilters };
		}, () => {
		  document.body.classList.toggle('no-scroll', this.state.showFilters);
		});
	  }

	componentWillUpdate( newProps ) {
		// Only fetch immediately for filter changes other than search term
		if ( this.props.selectedType !== newProps.selectedType || this.props.selectedJurisdiction !== newProps.selectedJurisdiction || this.props.pagination.perPage !== newProps.pagination.perPage || this.props.selectedStatus !== newProps.selectedStatus || this.props.pagination.pageNum !== newProps.pagination.pageNum ) {
			this.props.fetchOpinions();
		}
		// searchTerm changes are handled separately in the searchOpinions action with debouncing
	}

	componentDidUpdate() {
		let doc = document.documentElement,
		    top = (window.pageYOffset || doc.scrollTop
		          ) - (doc.clientTop || 0
		          );

		if ( 400 < top ) {
			smoothScroll( document.getElementById( 'opinions-list' ) );
		}
	}

	clearFilters( event ) {
		event.preventDefault();
		this.props.searchOpinions('');
	}

	// renderClearBtn() {
	// 	return (
	// 		<div>
	// 			<button type="button" id="btn-clear-opinion-keyword" className="btn-clear-inner-search" onClick={ this.clearFilters.bind( this ) } name="Clear all search filters">
	// 				<span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
	// 				Clear filters
	// 			</button>
	// 		</div>
	// 	);
	// }

	createOpinionHeading() {
		const params = new URLSearchParams( this.props.location.search );
		const selectedTypes = params.get( 'opinions' )
		                          ? params.get( 'opinions' ).split( ',' )
		                          : [];
		if ( selectedTypes.length > 0 && this.props.opinionTypes ) {
			const opinionNames = this.props.opinionTypes.filter(type => selectedTypes.includes(String(type.id))).map(type => type.name).join(', ');
			return (<div className="category-title-heading">
				<h2 className="blue-hero-title">Opinions Library :</h2>
				<div
					className={ 'sub-heading-names' }>
					<h4>{ opinionNames }</h4></div>
			</div>)
		}
		return <h2 className="blue-hero-title">Opinions Library</h2>;
	}

	render() {
		return (
			<div id="opinions-list">
			<div class="blue-hero-side-bar-opinions">
			<div class="container">
				    <div class="decoy-side-bar side-bar-container"></div>
					<OpinionsSideBar toggleFilters={this.toggleFilters} />
					{/* { this.renderClearBtn() } */}

					<div class="col-lg-9 main-content">
						<div>
							<div class="blue-hero-title-wrap large">

								{this.createOpinionHeading()}
					<div class="icon-chip">
						<span class="category-icon category-opinions" aria-hidden="true"></span>
					</div>
					</div>
				</div>
			</div>
		</div>
		</div>

			<div class="site-content container">
<div class="decoy-side-bar"></div>
<div class="col-lg-3 bookstore-sidebar">
</div>
<div class="col-lg-9 main-content show-content">
<button id="mobile-sidebar-options" onClick={this.toggleFilters}>Filter Options</button>

{this.props.loading ? (
  <Fragment>
    <Loading amount={4} width="100%" height={150} margin={30} />
  </Fragment>
) : (
	
  <Fragment>
	<LimitCount />
    {this.props.opinions.map(opinion => (
      <Opinion opinion={opinion} key={opinion.id} />
    ))}
  </Fragment>
)}
				<Pagination />

</div>
</div>
</div>
		);
	}
}

function mapStateToProps( { opinions, pagination, selectedJurisdiction, selectedType, selectedStatus, searchTerm, opinionTypes, loading } ) {
	return {
		opinions,
		pagination,
		selectedJurisdiction,
		selectedType,
		selectedStatus,
		searchTerm,
		opinionTypes,
		loading
	};
}

export default connect( mapStateToProps, { fetchOpinions, searchOpinions } )( OpinionsList );
